module.exports = __webpack_public_path__ + "static/media/mainTimelineChi.0fd21c92.png";